import { DayOfWeek } from '../../enums/DayOfWeek';

/**
 * The store banking days at which banking operations are performed.
 */
export class BankingSettings {
  startDate: string;
  days: DayOfWeek[];

  /**
   * @param startDate the Monday starting from which banking settings take effect.
   * @param days days of week at which banking operations are performed.
   */
  constructor(startDate: string, days: DayOfWeek[]) {
    this.startDate = startDate;
    this.days = days;
  }
}
